import { useEffect, useState, useRef, useMemo } from 'react';
import { io } from 'socket.io-client';
import { useProfile } from './auth/useProfile';

const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL || 'http://localhost:5500';
const SOCKET_URL = `${CHAT_API_URL}/chat`;

const ADMIN_PROFILES = {
    "7021350537": "JDecor",
    "9867486906": "JDecor Admin",
    "8007966656": "JDecor Admin",
     "9867486906": "JDecor Admin 1",
    "9823101210": "JDecor Admin 2",
    "8007966656": "JDecor Admin 3",
    "7030715353": "JDecor Admin 4",
    "9309801751": "JDecor Admin 5",
    "9309825636": "JDecor Admin 6",
    "9313089313": "JDecor Admin 7",
    "9270219270": "JDecor Admin 8",
    "9253279253": "JDecor Admin 9",
    "8720808872": "JDecor Admin 10",
    "9022684090":"JDecor Admin 11"
};

const isAdminNumber = (num) => {
    if (!num) return false;
    const cleanNum = num.toString().replace(/\D/g, "");
    return Object.keys(ADMIN_PROFILES).some(adminNum => cleanNum.endsWith(adminNum));
};

const getAdminName = (num) => {
    if (!num) return "JDecor";
    const cleanNum = num.toString().replace(/\D/g, "");
    const matchingKey = Object.keys(ADMIN_PROFILES).find(adminNum => cleanNum.endsWith(adminNum));
    return matchingKey ? ADMIN_PROFILES[matchingKey] : "JDecor";
};

export const useUnreadCount = (enabled = true) => {
    const mobno = localStorage.getItem("loginname") || "";
    
    // Fetch profile of the logged-in user dynamically
    const { data: profileData } = useProfile(mobno, { enabled: !!(mobno && enabled) });
    const profile = profileData?.Data?.[0] || {};
    const username = profile.username || "User";

    const isJdecorAdmin = isAdminNumber(mobno);

    const userData = useMemo(() => {
        if (!mobno || !enabled) return null;
        if (isJdecorAdmin) {
            return {
                _id: `user_jdecor_${mobno}`,
                name: getAdminName(mobno),
                role: "admin"
            };
        }
        return {
            _id: `user_${username.toLowerCase().replace(/\s+/g, '')}_${mobno}`,
            name: username,
            role: "client"
        };
    }, [username, mobno, isJdecorAdmin, enabled]);

    const [totalUnread, setTotalUnread] = useState(0);
    const socketRef = useRef(null);

    useEffect(() => {
        if (!enabled || !userData?._id) return;

        const socket = io(SOCKET_URL, {
            transports: ['websocket'],
            upgrade: false
        });
        socketRef.current = socket;

        const fetchAndCalculate = (roomsList) => {
            if (!roomsList || !Array.isArray(roomsList)) return;
            const sum = roomsList.reduce((acc, r) => acc + (r.unreadCount || 0), 0);
            setTotalUnread(sum);
        };

        socket.on('connect', () => {
            socket.emit('join', userData, (response) => {
                if (response?.rooms) {
                    fetchAndCalculate(response.rooms);
                }
            });
        });

        socket.on('connect_error', (err) => {
            console.error('useUnreadCount socket connection error:', err.message);
        });

        socket.on('update-room-list', () => {
            socket.emit('join', userData, (response) => {
                if (response?.rooms) {
                    fetchAndCalculate(response.rooms);
                }
            });
        });

        socket.on('messages-read', () => {
            socket.emit('join', userData, (response) => {
                if (response?.rooms) {
                    fetchAndCalculate(response.rooms);
                }
            });
        });

        socket.on('new-message', () => {
            socket.emit('join', userData, (response) => {
                if (response?.rooms) {
                    fetchAndCalculate(response.rooms);
                }
            });
        });

        return () => {
            socket.disconnect();
        };
    }, [userData]);

    return totalUnread;
};
